<template>
  <section>
    <div class="container">
      <main-text-block class="main-text" :title="title" :subtitle="subtitle" />
      <custom-button-join :is-white="isWhite" class="main-button" />
      <main-guarantee-block :guarantee-text="guaranteeText" />
    </div>
  </section>
</template>

<script>
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";
import MainGuaranteeBlock from "@/components/main/mainSlide/modules/MainGuaranteeBlock.vue";
import MainTextBlock from "@/components/main/mainSlide/modules/MainTextBlock.vue";

export default {
  name: "main-slide",
  components: {
    MainTextBlock,
    MainGuaranteeBlock,
    CustomButtonJoin,
  },
  data() {
    return {
      title: "Час полювати",
      subtitle: "Обирай свій шлях",
      guaranteeText: [
        "гарантовано 60+ днів підготовки",
        "можливість обрати бригаду",
        "служба за контрактом",
      ],
      isWhite: true,
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  background: url("@/assets/images/main-slide/background.png") no-repeat center
    center/cover;
  width: 100%;
  height: 100vh;
  max-height: 800px;
  color: white;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 767px) {
    max-height: 562px;
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    margin-top: 145px;

    @media (max-width: 767px) {
      margin-top: 185px;
    }

    .main-button {
      width: 557px;
      height: 70px;

      @media (max-width: 767px) {
        position: absolute;
        bottom: 0;
        left: 0;
        width: calc(100% - 50px);
        margin: 0 22px 50px 22px;
      }

      @media (min-width: 768px) and (max-width: 1360px) {
        width: calc(100% - 50px);
        height: 70px;
        position: absolute;
        bottom: 30px;
      }
    }
  }
}

.bg-white {
  &:before,
  &:after {
    background: white;
  }
}
</style>
